/**
 * BatchCurlSnippet — the POST /v1/batches sample for a pipeline's empty
 * state, with a copy button. The text itself comes from batchCurl.ts.
 */

import { CopyButton } from '@/components/ui/copy-button'

import { batchCurlSnippet, type SnippetPipeline } from './batchCurl'

interface BatchCurlSnippetProps {
  pipeline: SnippetPipeline
  /** The team's S3 connection to submit through; null renders a placeholder. */
  connectionId: string | null
}

export function BatchCurlSnippet({
  pipeline,
  connectionId,
}: BatchCurlSnippetProps): React.JSX.Element {
  const snippet = batchCurlSnippet(pipeline, connectionId)
  return (
    <div className="relative max-w-full">
      <pre className="max-w-full overflow-x-auto bg-muted p-3 pr-10 text-left font-mono text-xs text-muted-foreground">
        {snippet}
      </pre>
      <CopyButton value={snippet} label="Copy sample request" className="absolute right-2 top-2" />
    </div>
  )
}
